<template lang="pug">
.map-switches
  .uk-grid-small.uk-flex
    div
      .uk-text-center.uk-text-small(style="font-size: 11px") 大雨キキクル
      .uk-grid-small.uk-flex.uk-flex-middle(uk-grid)
        div
          label.switch
            input(type="checkbox", v-model="kikikuru_layer_is_show")
            span

    div(v-if="is_winter")
      .uk-text-center.uk-text-small(style="font-size: 11px") 今後の雪
      .uk-grid-small.uk-flex.uk-flex-middle(uk-grid)
        div
          label.switch
            input(type="checkbox", v-model="snowd_layer_is_show")
            span

    div(v-else)
      .uk-text-center.uk-text-small(style="font-size: 11px") 今後の雨
      .uk-grid-small.uk-flex.uk-flex-middle(uk-grid)
        div
          label.switch
            input(type="checkbox", v-model="raind_layer_is_show")
            span

</template>

<script>
import * as types from "../js/mutations/map-mutations"

export default {
  computed: {
    is_winter () { return this.$store.getters.is_winter },
    kikikuru_layer_is_show: {
      get () { return this.$store.getters.kikikuru_layer_is_show },
      set (value) { this.$store.dispatch(types.TOGGLE_LAYER, {layer_name: 'kikikuru_layer', state: value, type: 'front_switch'}) }
    },
    snowd_layer_is_show: {
      get () { return this.$store.getters.snowd_layer_is_show },
      set (value) { this.$store.dispatch(types.TOGGLE_LAYER, {layer_name: 'snowd_layer', state: value, type: 'front_switch'}) }
    },
    raind_layer_is_show: {
      get () { return this.$store.getters.raind_layer_is_show },
      set (value) { this.$store.dispatch(types.TOGGLE_LAYER, {layer_name: 'raind_layer', state: value, type: 'front_switch'}) }
    }
  },
}
</script>
